import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';
import { SharedRankingListService } from 'src/app/@theme/components/shared-ranking-list/shared-ranking-list.service';

import { DEPARTMENT_PATH_KIDS, DEPARTMENT_TYPE_KIDS } from 'src/app/core/constants';
import { SharedSidebarService } from 'src/app/@theme/components';
import { Title } from '@angular/platform-browser';
import { SetupService } from '@core/services/setup';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-kids',
    templateUrl: './kids.component.html',
    styleUrls: ['./kids.component.scss'],
})
export class KidsComponent implements OnInit, OnDestroy {
    /**
     * Rota ativa
     */
    public activeRoute: string = this.router.url;

    /**
     * Definição da identificão da sessão/depto kids
     */
    public departmentId: string = '29';
    public departmentType: string = DEPARTMENT_TYPE_KIDS;

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any;

    pageTitle = this.translateService.instant('PAGES.KIDS');

    overviewImage: string;

    constructor(
        private router: Router,
        private sharedSidebarService: SharedSidebarService,
        private title: Title,
        private setupService: SetupService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.watchActiveRoute();
        this.sideMenu();
        this.title.setTitle(`${this.pageTitle} - ${this.setupService.title}`);
        this.overviewImage = this.setupService.images?.header?.kids;
        this.setupService.setFooterImageFromDepartment(DEPARTMENT_PATH_KIDS);
    }

    private watchActiveRoute() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => (this.activeRoute = event.url));
    }

    /**
     * onPageChange - evento da paginação
     * retorno do evento:
     *  - numero da página selecionada
     *  ex: 4
     *
     * pode-se fazer uma nova requisição passando
     * o número da página como parametro e substituir
     * a propriedade que salva as notícias
     */
    onPageChange(pageNumber) {
        //console.log(pageNumber);
    }

    sideMenu() {
        this.sharedSidebarService.getSideMenu(this.departmentType).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
    }

    ngOnDestroy(): void {
        this.setupService.setFooterImage();
    }
}
